import getSelectedFolderView from '../selectors/getSelectedFolderView';
import Todo from '../store/schema/Todo';

export default function selectTodoById(itemId: string): Todo | null {
    const selectedFolder = getSelectedFolderView();
    return selectedFolder.todoItems.get(itemId);
}
